"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var vp_footer_1 = __importDefault(require("@components/vp-footer"));
var culture_1 = require("./culture");
var Logo_1 = __importDefault(require("./Logo"));
var EBTFooter = function (_a) {
    var cultureCode = _a.cultureCode, isLarge = _a.isLarge;
    return (react_1.default.createElement(vp_footer_1.default, { externalConfig: culture_1.getFooterConfig(cultureCode), isLarge: isLarge, Logo: Logo_1.default }));
};
EBTFooter.displayName = 'EBTFooter';
exports.default = EBTFooter;
__exportStar(require("./types"), exports);
